export const CONTACT = {
  phone: "(423) 555-0100",
  phoneHref: "tel:+14235550100",
  email: "newmanconstructiontn@gmail.com",
  region: "Serving the Tri-Cities region",
};

export const img = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  deckGlass: "1787491581076-2e4362a3eb56",
  deckCovered: "1783125127094-ea962d41ba42",
  pergola: "1766603636787-d48785d00367",
  garage: "1775430766327-ca7d9f93f563",
  garageMulti: "1783125127264-68ce8f450854",
  siding: "1727668441719-a4f3f38f07ce",
  boardBatten: "1675747159044-cd54aec604e5",
  newHome: "1494526585095-c41746248156",
  patio: "1694885090746-d90472e11c0e",
  pergolaBench: "1674672670977-bcf517fc2376",
};

const media = (name) => ({ webm: `/media/${name}-reveal.webm`, mp4: `/media/${name}-reveal.mp4`, poster: `/media/${name}-poster.jpg` });

export const VIDEOS = { exterior: media("exterior"), interior: media("interior") };

export const NAV = [
  { id: "transformations", label: "Before / After" },
  { id: "services", label: "Services" },
  { id: "explorer", label: "3D Deck" },
  { id: "about", label: "About Matt", route: "/about" },
  { id: "region", label: "Region" },
];

export const CITIES = ["Johnson City", "Kingsport", "Bristol", "Elizabethton", "Jonesborough", "Gray", "Blountville", "Piney Flats"];

export const PROJECT_TYPES = ["New deck", "Covered porch", "Siding", "Exterior upgrade", "Something else"];
